var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.898 2.562a1.001 1.001 0 0 0-1.8 0l-2.01 4.134-4.487.662a.998.998 0 0 0-.556 1.7L5.3 12.28l-.769 4.554a1.003 1.003 0 0 0 1.46 1.05L10 15.743l4.01 2.14a1 1 0 0 0 1.056-.071c.309-.225.465-.604.403-.979l-.772-4.553 3.256-3.222a.999.999 0 0 0-.556-1.7l-4.49-.662z"
  })));
};
export default SvgStarFilled;